// client/src/pages/LegalPageBody.jsx
import React from "react";
import { applyProviderVars, getLegalText, LEGAL_PAGES } from "./legalContent.js";

function TextBlock({ text }) {
  const lines = String(text || "").split("\n");

  if (lines.length <= 1) return <p>{text}</p>;

  return (
    <p>
      {lines.map((line, index) => (
        <React.Fragment key={`${line}-${index}`}>
          {line}
          {index < lines.length - 1 && <br />}
        </React.Fragment>
      ))}
    </p>
  );
}

export default function LegalPageBody({ slug, lang, beforeSections = null, afterSections = null }) {
  const page = LEGAL_PAGES[slug];

  if (!page) return null;

  const translate = (value) => applyProviderVars(getLegalText(value, lang), lang);

  return (
    <>

      {beforeSections}

      {page.sections?.map((section, index) => (
        <section className="legalPage__section" key={`${slug}-${index}`}>
          {section.h && <h2>{translate(section.h)}</h2>}

          {section.p?.map((paragraph, pIndex) => (
            <TextBlock key={`p-${pIndex}`} text={translate(paragraph)} />
          ))}

          {section.list?.length > 0 && (
            <ul>
              {section.list.map((item, itemIndex) => (
                <li key={`li-${itemIndex}`}>{translate(item)}</li>
              ))}
            </ul>
          )}
        </section>
      ))}

      {afterSections}
    </>
  );
}
